import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Get the base URL from the document
		const baseHref = document.getElementsByTagName('base')[0].href;

		// For API calls, ensure the proper baseHref is included
		if (request.url.startsWith('/api')) {
			// Remove trailing slash from baseHref if any
			const normalizedBaseHref = baseHref.endsWith('/') ? baseHref.slice(0, -1) : baseHref;

			// Remove leading slash from request URL
			const normalizedUrl = request.url.startsWith('/') ? request.url.slice(1) : request.url;

			// Create the full URL
			const fullUrl = `${normalizedBaseHref}/${normalizedUrl}`;

			// Clone request with the updated URL
			const modifiedRequest = request.clone({
				url: fullUrl
			});

			return next.handle(modifiedRequest);
		}

		return next.handle(request);
	}
}